var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"review-plan-list"},_vm._l((_vm.plans),function(plan){return _c('PlanListItem',{key:plan.id,attrs:{"plan":plan,"selected":_vm.selected.some(f => f.planId === plan.id)},on:{"click":function($event){return _vm.selectPlan(plan.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }